<template>
    <div class="failed">
        <h1>Helaas</h1>
        <h2>Je hebt niet genoeg appels gescoord...</h2>
        <button @click="restart" class="buttonAgain">
            <h3>Probeer opnieuw</h3>
        </button>
    </div>
</template>

<script>
export default {
    name: "failed",
    components: {
    },
    props: {
    },
    computed: {
    },
    methods: {
        restart() {
            this.$emit("restart");
        }
    }
};
</script>
<style scoped>

h1 {
    font-size: 5vh;
    margin: 0;
    color: white;
    text-shadow: 0.8vh 0.8vh 0 #DB5900, -0.4vh -0.4vh 0 #DB5900, 0.4vh -0.4vh 0 #DB5900,-0.4vh 0.4vh 0 #DB5900, 0.4vh 0.4vh 0 #DB5900;
}
h2 {
    font-size: 4vh;
    margin: 5vh 0;
    color: white;
    text-shadow: 0.8vh 0.8vh 0 #DB5900, -0.4vh -0.4vh 0 #DB5900, 0.4vh -0.4vh 0 #DB5900,-0.4vh 0.4vh 0 #DB5900, 0.4vh 0.4vh 0 #DB5900;
}
h3 {
    font-size: 2.5vh;
    margin-top:-2vh;
    color: #fff;
}
.failed {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 15vh 0;
    background: rgba(22, 0, 0, 0.8);
}
.buttonAgain {
    display: inline-block;
    width: 40%;
    height: 30%;
    background:none;
    border:none;
    background-image: url(../assets/images/button-orange-up.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    margin:2vh;
}
.buttonAgain:hover {
    cursor: pointer;
    background-image: url(../assets/images/button-green-up.svg);
}
.buttonAgain:active {
    cursor: pointer;
    background-image: url(../assets/images/button-green-down.svg);
}
.buttonAgain:active h3 {
    margin-top:1vh;
}
</style>
